import {
  SubscriptionFlowProps,
  SubscriptionFlowStatus,
} from "@features/Subscription/subscription.types";
import {
  GetSubscriptionFlowStateResponse,
  MembershipAffiliationDto,
} from "@shared/apis/sidekick/generated";

export const convertSubscriptionFlowStateToSubscriptionFlowProps = ({
  data,
  partner,
}: {
  data: GetSubscriptionFlowStateResponse;
  partner: MembershipAffiliationDto | null;
}): SubscriptionFlowProps => {
  const props: SubscriptionFlowProps = {
    defaultValues: {
      email: data.userEmail ?? "",
      name: data.userInfo?.name ?? "",
      phoneNumber: data.userInfo?.phoneNumber ?? "",
      mlsId: data.userInfo?.mlsId ?? "",
      officeName: data.userInfo?.officeName ?? "",
      address: {
        line1: data.userAddress?.line1 ?? "",
        line2: data.userAddress?.line2 ?? "",
        state: data.userAddress?.state ?? "",
        city: data.userAddress?.city ?? "",
        zipCode: data.userAddress?.zipCode ?? "",
        country: data.userAddress?.country ?? "",
      },
    },
    subscriptionId: data.id,
    subscriptionInfo: {
      name: data.startSubscriptionPaymentData.product,
      price: data.startSubscriptionPaymentData.price,
      currency: data.startSubscriptionPaymentData.currency,
      clientSecret: data?.startSubscriptionPaymentData.clientSecret,
      availableOffer: data.startSubscriptionPaymentData.availableOffer
        ? {
            id: data.startSubscriptionPaymentData.availableOffer.offerId,
            trialDays:
              data.startSubscriptionPaymentData.availableOffer?.trialDays,
            validUntil:
              data.startSubscriptionPaymentData.availableOffer.validUntil,
            price: data.startSubscriptionPaymentData.availableOffer?.price,
          }
        : undefined,
      creditCardRequired: data.creditCardRequired ?? true,
    },
    planInfo: {
      id: data.planInfo.id,
      name: data.planInfo.name,
      trialDays: data.planInfo.trialDays,
    },
    status: data.status as SubscriptionFlowStatus,
    lastPaymentFailedReason: data.lastPaymentFailedReason,
    partner,
  };

  return props;
};

export const REGISTRATION_OPTION_STORAGE_KEY = "@sidekick:registration-option";
